import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookmarkCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBookmarkCheck"><Path d="M19.5 21V2.5H4.5V21L12 17L19.5 21Z" stroke="currentColor" strokeLinecap="square"/><Path d="M9.19995 10.3L11 12.1L15.2 7.90002" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBookmarkCheck;
